export default __webpack_public_path__ + "static/media/timer.696b12df.svg";